import { SystemStyleObject } from '@indeed/ifl-css/ts/types';

// Temporary solution until full jspro theme is implemented

const jsProThemeTokens = {
    colors: {
        jsPro: {
            background: {
                primary: '#2D2D2D',
            },
            foreground: {
                primary: '#2D2D2D',
                inverse: '#FFFFFF',
            },
        },
    },
};

export const jsProThemeButton = {
    primary: {
        backgroundColor: jsProThemeTokens.colors.jsPro.background.primary,
        color: jsProThemeTokens.colors.jsPro.foreground.inverse,
        '&:hover:not([aria-disabled="true"])': {
            backgroundColor: '#424242',
        },
        '&:active:not([aria-disabled="true"])': {
            backgroundColor: '#595959',
        },
        '&[aria-disabled="true"]': {
            opacity: 0.5,
            cursor: 'not-allowed',
        },
    } satisfies SystemStyleObject,
    tertiary: {
        color: jsProThemeTokens.colors.jsPro.foreground.primary,
        '&:hover:not([aria-disabled="true"])': {
            color: jsProThemeTokens.colors.jsPro.foreground.primary,
        },
        '&:active:not([aria-disabled="true"])': {
            color: jsProThemeTokens.colors.jsPro.foreground.primary,
        },
        'span:first-of-type': {
            'svg:first-of-type': {
                'circle:last-of-type': {
                    stroke: jsProThemeTokens.colors.jsPro.foreground.primary,
                },
            },
        },
    } satisfies SystemStyleObject,
} as const;

export const jsProThemeProgressBar = {
    borderColor: jsProThemeTokens.colors.jsPro.background.primary,
    'div:first-of-type': {
        backgroundColor: jsProThemeTokens.colors.jsPro.background.primary,
    },
} satisfies SystemStyleObject;
